/* collapsible-tabs carousel merged implementation */
(function(){
  function initCarousel(root){
    var track = root.querySelector('.collapsible-tabs__carousel-track');
    if(!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if(!slides.length) return;
    var prev = root.querySelector('.collapsible-tabs__carousel-prev');
    var next = root.querySelector('.collapsible-tabs__carousel-next');
    var index = 0;

    var realCount = slides.length;
    var isLoop = realCount > 1;

    var viewport = root.querySelector('.collapsible-tabs__carousel');
    var slideWidth = 0;

    var trackChildrenCount = 0;
    function recalcSizes(){
      var w = 0;
      if(viewport) w = Math.round(viewport.getBoundingClientRect().width) || 0;
      if(!w && track.children.length) w = Math.round(track.children[0].getBoundingClientRect().width) || w;
      slideWidth = w || slideWidth;
      if(!slideWidth) return;
      trackChildrenCount = track.children.length;
      for(var i=0;i<trackChildrenCount;i++){
        var ch = track.children[i];
        ch.style.minWidth = slideWidth + 'px';
        ch.style.flex = '0 0 ' + slideWidth + 'px';
      }
      track.style.width = (trackChildrenCount * slideWidth) + 'px';
    }

    if(isLoop){
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[realCount - 1].cloneNode(true);
      track.appendChild(firstClone);
      track.insertBefore(lastClone, track.firstChild);
      slides = Array.prototype.slice.call(track.children);
      index = 1;
      recalcSizes();
      track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (-index * slideWidth) + 'px,0,0)';
      requestAnimationFrame(function(){ track.style.transition = 'transform .36s ease'; });
    } else {
      index = 0;
      recalcSizes();
      track.style.transform = 'translate3d(0px,0,0)';
    }

    var dotsContainer = root.querySelector('.collapsible-tabs__dots');

    function updateDots(){
      if(!dotsContainer) return;
      var logical = isLoop ? (index - 1) : index;
      logical = ((logical % realCount) + realCount) % realCount;
      var children = dotsContainer.children;
      for(var i=0;i<children.length;i++){
        children[i].classList.toggle('is-active', i === logical);
      }
    }

    function renderDots(){
      if(!dotsContainer) return;
      dotsContainer.innerHTML = '';
      for(var i=0;i<realCount;i++){
        (function(i){
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ct-dot';
          btn.setAttribute('aria-label', 'Go to slide ' + (i+1));
          btn.addEventListener('click', function(){ if(isAnimating) return; var target = isLoop ? (i + 1) : i; index = target; update(true); isAnimating = true; setButtonsDisabled(true); });
          dotsContainer.appendChild(btn);
        })(i);
      }
      updateDots();
    }

    (function(){
      try{
        if(window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches && viewport){
          var hint = document.createElement('div');
          hint.className = 'collapsible-tabs__swipe-hint';
          hint.innerHTML = '<span class="chev">‹</span><span>Swipe</span><span class="chev">›</span>';
          viewport.appendChild(hint);
          var hide = function(){ if(!hint) return; hint.classList.add('is-hidden'); setTimeout(function(){ try{ hint && hint.remove(); }catch(e){} }, 300); hint = null; };
          var t = setTimeout(hide, 2000);
          var userHide = function(){ clearTimeout(t); hide(); };
          if(window.PointerEvent){
            track.addEventListener('pointerdown', userHide, {once:true});
          } else {
            track.addEventListener('touchstart', userHide, {passive:true, once:true});
            track.addEventListener('mousedown', userHide, {once:true});
          }
        }
      }catch(e){}
    })();

    // render dots for pagination
    if(dotsContainer){ renderDots(); }

    function update(animate, forceRecalc){
      if(forceRecalc || !slideWidth) recalcSizes();
      if(!slideWidth){ return; }
      if(animate === false) track.style.transition = 'none';
      else track.style.transition = 'transform .36s ease';
      track.style.transform = 'translate3d(' + (-index * slideWidth) + 'px,0,0)';
      updateDots();
    }

    var isAnimating = false;
    function setButtonsDisabled(v){ if(prev) prev.disabled = v; if(next) next.disabled = v; }
    if(prev){ prev.addEventListener('click', function(){ if(isAnimating) return; index = index - 1; update(true); isAnimating = true; setButtonsDisabled(true); }); }
    if(next){ next.addEventListener('click', function(){ if(isAnimating) return; index = index + 1; update(true); isAnimating = true; setButtonsDisabled(true); }); }

    Array.prototype.forEach.call(track.querySelectorAll('img'), function(img){ img.draggable = false; img.style['-webkit-user-drag'] = 'none'; });

    var startX = 0, delta = 0, isDragging = false;

    function onPointerMove(clientX){ if(!isDragging || !slideWidth) return; delta = clientX - startX; track.style.transform = 'translate3d(' + ((-index * slideWidth) + delta) + 'px,0,0)'; }
    function endDrag(){ track.style.transition = 'transform .36s ease'; track.classList.remove('is-dragging'); if(slideWidth && Math.abs(delta) > (slideWidth * 0.15)){ if(delta < 0){ index = index + 1; } else { index = index - 1; } isAnimating = true; setButtonsDisabled(true); } update(true); delta = 0; isDragging = false; }

    if (window.PointerEvent) {
      var activePointerId = null;
      track.addEventListener('pointerdown', function(e){
        if(e.button !== 0) return;
        if(isAnimating) return;
        recalcSizes();
        startX = e.clientX; isDragging = true; track.style.transition = 'none'; track.classList.add('is-dragging');
        activePointerId = e.pointerId;
        try { track.setPointerCapture(activePointerId); } catch(err) {}
        e.preventDefault();
      }, {passive:false});

      track.addEventListener('pointermove', function(e){ if(!isDragging || e.pointerId !== activePointerId) return; onPointerMove(e.clientX); }, {passive:true});

      function onPointerUp(e){ if(e.pointerId !== activePointerId) return; endDrag(); try { track.releasePointerCapture(activePointerId); } catch(err) {} activePointerId = null; }
      track.addEventListener('pointerup', onPointerUp, {passive:true});
      track.addEventListener('pointercancel', onPointerUp, {passive:true});
    } else {
      track.addEventListener('touchstart', function(e){
        if(isAnimating) return;
        recalcSizes();
        startX = e.touches[0].clientX; isDragging = true; track.style.transition = 'none'; track.classList.add('is-dragging');
      }, {passive:true});
      track.addEventListener('touchmove', function(e){ if(!isDragging) return; onPointerMove(e.touches[0].clientX); }, {passive:true});
      track.addEventListener('touchend', function(){ if(!isDragging) return; endDrag(); }, {passive:true});
      track.addEventListener('touchcancel', function(){ if(isDragging) endDrag(); }, {passive:true});

      function onMouseMove(e){ onPointerMove(e.clientX); }
      function onMouseUp(e){ endDrag(); document.removeEventListener('mousemove', onMouseMove); document.removeEventListener('mouseup', onMouseUp); }

      track.addEventListener('mousedown', function(e){
        if(e.button !== 0) return;
        if(isAnimating) return;
        recalcSizes();
        startX = e.clientX; isDragging = true; track.style.transition = 'none'; track.classList.add('is-dragging');
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        e.preventDefault();
      });
    }

    var resizeRaf = null;

    track.addEventListener('transitionend', function(){
      if(isLoop){
      if(index === 0){
        track.style.transition = 'none';
        index = realCount;
        recalcSizes();
        track.style.transform = 'translate3d(' + (-index * slideWidth) + 'px,0,0)';
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ track.style.transition = 'transform .36s ease'; }); });
      }
      if(index === realCount + 1){
        track.style.transition = 'none';
        index = 1;
        recalcSizes();
        track.style.transform = 'translate3d(' + (-index * slideWidth) + 'px,0,0)';
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ track.style.transition = 'transform .36s ease'; }); });
      }
      }
      isAnimating = false;
      setButtonsDisabled(false);
      updateDots();
    });

    root.setAttribute('tabindex', '-1');
    root.addEventListener('keydown', function(e){ if(e.key === 'ArrowLeft'){ prev && prev.click(); } if(e.key === 'ArrowRight'){ next && next.click(); } });

    window.addEventListener('resize', function(){
      if(resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function(){ update(false, true); resizeRaf = null; });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    var nodes = document.querySelectorAll('[data-collapsible-carousel]');
    Array.prototype.forEach.call(nodes, initCarousel);
  });
})();
